module.exports = __webpack_public_path__ + "static/img/AMR-036-2.4b531b8e.jpg";